import type { LoaderFunction } from 'react-router-dom';
import { apiListComplete } from "../../components/ui_components/ApiList";
import { combineAdminLoader } from "./AdminRouteProtection";

const PpvHandlerLoaderInternal: LoaderFunction = async () => {
    try {
        const response = await apiListComplete();
        return response;
    } catch (error) {
        throw new Error('Failed to load PPV list');
    }
};

// Wrapper con protezione admin
export const PpvHandlerLoader: LoaderFunction = combineAdminLoader(PpvHandlerLoaderInternal);
